module.exports = __webpack_public_path__ + "d55959d03d2331cb8f93986199aaa7cc.jpg";